import Template from "./template";
const ButtomBanner = Template;
export default ButtomBanner;
